module.exports = __webpack_public_path__ + "img/icon_utility.0a667f78.png";